import React from 'react';
import Select from '../../commonComponents/util/Select';

export default class UpdateSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            initialValue: this.props.value || '',
            newValue: this.props.value || '',
            error: false,
            sucess: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.initialValue) {
            this.setState({ initialValue: nextProps.value, newValue: nextProps.value });
        }
    }

    onChange(e) {
        this.setState({ newValue: e.target.value, error: false, success: false }, async () => {
            await this.props.update(this.state.newValue);
            if (!this.props.success) {
                this.setState({ error: true, newValue: this.props.value || '' });
            } else {this.setState({success: true})}
        });

    }

    render() {
        return (
            <div className="update-select relative">
                <label className="input-label">{this.props.title}</label>
                <Select options={this.props.options} value={this.state.newValue} onChange={this.onChange.bind(this)} />
                {this.props.loading && <p className="small-text accent-text2"><i className="icon-reload icon-left"></i>Saving...</p>}
                {this.state.success && <p className="small-text approved-text"><i className="icon icon-left ion-checkmark-round"></i>Saved</p>}
                {this.state.error && <p className="error-label">Oops, something went wrong. Please try again.</p>}
            </div>
        );
    }
}

//options, value, title, update, loading, success


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/UpdateSelect.jsx